import * as React from 'react';
import { getBasePath } from '../../utils/browser';

export interface NewCloseButtonProps {
  onClick: (ev: React.MouseEvent<HTMLAnchorElement>) => void;
}

type ButtonState = 'normal' | 'hovered' | 'selected';

interface NewCloseButtonState {
  buttonState: ButtonState;
}

class NewCloseButton extends React.Component<NewCloseButtonProps, NewCloseButtonState> {
  public constructor(props: NewCloseButtonProps) {
    super(props);
    this.state = { buttonState: 'normal' };
  }

  public render() {
    const baseDir = getBasePath();

    let imgUrl = '';
    switch (this.state.buttonState) {
      case 'normal':
        imgUrl = `url('${baseDir}/images/setting-popup/btn_x_out.png')`;
        break;
      case 'hovered':
        imgUrl = `url('${baseDir}/images/setting-popup/btn_x_over.png')`;
        break;
      case 'selected':
        imgUrl = `url('${baseDir}/images/setting-popup/btn_x_selected.png')`;
        break;
    }

    const style: React.CSSProperties = {
      width: '30px',
      height: '30px',
      backgroundImage: imgUrl,
      backgroundSize: 'contain',
    };

    return (
      <a
        onClick={this.props.onClick}
        onMouseEnter={() => this.setState({ buttonState: 'hovered' })}
        onMouseLeave={() => this.setState({ buttonState: 'normal' })}
        onMouseDown={() => this.setState({ buttonState: 'selected' })}
        onTouchStart={() => this.setState({ buttonState: 'selected' })}
        onPointerDown={() => this.setState({ buttonState: 'selected' })}
        onMouseUp={() => this.setState({ buttonState: 'normal' })}
        onTouchEnd={() => this.setState({ buttonState: 'normal' })}
        onPointerUp={() => this.setState({ buttonState: 'normal' })}
        onTouchCancel={() => this.setState({ buttonState: 'normal' })}
        onPointerCancel={() => this.setState({ buttonState: 'normal' })}
        style={style} />
    );
  }
}

export default NewCloseButton;
